import {
  MembershipActions as RCMembershipActions,
  MembershipActionTypes as RCMembershipActionTypes,
} from '@features/redeem-cash-v2/store/actions/membership.actions';
import {
  MembershipActions as TCMembershipActions,
  MembershipActionTypes as TCMembershipActionTypes,
} from '@features/transfer-connect-v2/store/actions/membership.actions';
import { Membership } from '@rd/types';
import { toObject } from '@rd/utils/array.utils';
import {
  linkMembership,
  linkMembershipFail,
  MembershipActions,
  MembershipActionTypes,
  unlinkMembership,
  unlinkMembershipFail,
} from '../actions/membership.actions';

export interface MembershipState {
  memberships: {
    data: {
      [key: string]: Membership;
    };
    error: boolean;
    isLoaded: boolean;
    loading: boolean;
  };
  createMembership: {
    error: boolean;
    loading: boolean;
    success: boolean;
  };
  updateMembership: {
    error: boolean;
    loading: boolean;
    success: boolean;
  };
  linkMembership: {
    error: boolean;
    loading: boolean;
  };
  unlinkMembership: {
    error: boolean;
    loading: boolean;
  };
}

const initialState: MembershipState = {
  memberships: {
    data: {},
    error: false,
    isLoaded: false,
    loading: false,
  },
  createMembership: {
    error: false,
    loading: false,
    success: false,
  },
  updateMembership: {
    error: false,
    loading: false,
    success: false,
  },
  linkMembership: {
    error: false,
    loading: false,
  },
  unlinkMembership: {
    error: false,
    loading: false,
  },
};

export function membershipReducer(
  state: MembershipState = initialState,
  action: MembershipActions | RCMembershipActions | TCMembershipActions,
): MembershipState {
  switch (action.type) {
    case MembershipActionTypes.LOAD_ALL_MEMBERSHIPS:
      return {
        ...state,
        memberships: {
          ...state.memberships,
          loading: true,
        },
      };

    case MembershipActionTypes.LOAD_ALL_MEMBERSHIPS_SUCCESS:
      return {
        ...state,
        memberships: {
          data: toObject(action.payload, 'id'),
          error: false,
          isLoaded: true,
          loading: false,
        },
      };

    case MembershipActionTypes.LOAD_ALL_MEMBERSHIPS_FAIL:
      return {
        ...state,
        memberships: {
          ...state.memberships,
          error: true,
          loading: false,
        },
      };

    case MembershipActionTypes.CREATE_MEMBERSHIP:
      return {
        ...state,
        createMembership: {
          success: false,
          error: false,
          loading: true,
        },
      };

    // TODO: Remove this once RCv2 and TCv2 migrate to using membership facade in checkout component
    case MembershipActionTypes.CREATE_MEMBERSHIP_SUCCESS:
    case TCMembershipActionTypes.CREATE_MEMBERSHIP_SUCCESS:
    case RCMembershipActionTypes.CREATE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        createMembership: {
          error: false,
          loading: false,
          success: true,
        },
      };

    case MembershipActionTypes.CREATE_MEMBERSHIP_FAIL:
      return {
        ...state,
        createMembership: {
          error: true,
          loading: false,
          success: false,
        },
      };

    case MembershipActionTypes.UPDATE_MEMBERSHIP:
      return {
        ...state,
        updateMembership: {
          error: false,
          loading: true,
          success: false,
        },
      };

    // TODO: Remove this once RCv2 and TCv2 migrate to using membership facade in checkout component
    case MembershipActionTypes.UPDATE_MEMBERSHIP_SUCCESS:
    case RCMembershipActionTypes.UPDATE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        updateMembership: {
          error: false,
          loading: false,
          success: true,
        },
      };
    // TODO: Remove this once RCv2 and TCv2 migrate to using membership facade in checkout component
    // TCv2 Update membership success data shape is different
    case TCMembershipActionTypes.UPDATE_MEMBERSHIP_SUCCESS:
      return {
        ...state,
        memberships: {
          ...state.memberships,
          data: {
            ...state.memberships.data,
            [action.payload.membership.id]: action.payload.membership,
          },
        },
        updateMembership: {
          error: false,
          loading: false,
          success: true,
        },
      };

    case MembershipActionTypes.UPDATE_MEMBERSHIP_FAIL:
      return {
        ...state,
        updateMembership: {
          error: true,
          loading: false,
          success: false,
        },
      };

    case MembershipActionTypes.CLEAR_CREATE_AND_UPDATE_MEMBERSHIP_ERRORS:
      return {
        ...state,
        createMembership: {
          ...state.createMembership,
          error: false,
        },
        updateMembership: {
          ...state.updateMembership,
          error: false,
        },
      };
    case linkMembership.type: {
      return {
        ...state,
        linkMembership: {
          loading: true,
          error: false,
        },
      };
    }
    case linkMembershipFail.type: {
      return {
        ...state,
        linkMembership: {
          loading: false,
          error: true,
        },
      };
    }
    case unlinkMembership.type: {
      return {
        ...state,
        unlinkMembership: {
          loading: true,
          error: false,
        },
      };
    }
    case unlinkMembershipFail.type: {
      return {
        ...state,
        unlinkMembership: {
          loading: false,
          error: true,
        },
      };
    }
  }
  return state;
}
